/** Field rules shared by the invite form and the inline edits in the user and invite tables. */
export const emailRules = {
  required: "Email is required",
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: "Invalid email address",
  },
};

/** Matches the backend's company_name columns. */
const COMPANY_MAX_LENGTH = 255;
const COMPANY_TOO_LONG = `Company name must be at most ${COMPANY_MAX_LENGTH} characters.`;

export const companyRules = {
  setValueAs: (value: string) => value.trim(),
  maxLength: { value: COMPANY_MAX_LENGTH, message: COMPANY_TOO_LONG },
};

export const validateEmail = (value: string) =>
  !value
    ? emailRules.required
    : emailRules.pattern.value.test(value)
      ? null
      : emailRules.pattern.message;

/** For trimmed values; a user's company is required, an invitation's is optional. */
export const validateCompany = (value: string, required: boolean) =>
  required && !value
    ? "Company name is required."
    : value.length > COMPANY_MAX_LENGTH
      ? COMPANY_TOO_LONG
      : null;
